<div class="choose-customer-wrapper">
    <div class="result-container">
      <div class="customer" *ngFor="let customer of customerData" (click)="onSelect(customer)">
        <div class="name">
          <span>{{customer.firstName}} {{customer.lastName}}</span>
          <div class="customer-row">
            <div class="text text-phone" *ngIf="!customer.drvaFlag">{{customer.phoneNumber | phone}}</div>
            <div class="text text-email" *ngIf="!customer.drvaFlag">· {{customer.emailAddress}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="search-buttons">
        <button class="cancel-button" (click)="onCancel()">Cancel</button>
    </div>
  </div>
  